import React from 'react'
import { useInternalState } from './hooks'
import { Pane } from 'components/shared/Pane/Pane'

export const Career = () => {
  const { activeTab, tab, tabs, handleTabChange } = useInternalState()

  return (
    <Pane tagName="section">
      <Pane.TabsBar onClick={handleTabChange} {...{ activeTab, tabs }} />
      {tab}
    </Pane>
  )
}
